// extracted by mini-css-extract-plugin
export var attachment = "_o1-a";
export var emailContainer = "_o1-4";
export var emailContentPaddedContainer = "_o1-b";
export var emailHeader = "_o1-6";
export var emailIframe = "_o1-3";
export var emailInfoIcon = "_o1-9";
export var emailShortenedSummary = "_o1-e";
export var infoDropdown = "_o1-0";
export var infoRowBoundedContent = "_o1-d";
export var internal = "_o1-5";
export var merchant = "_o1-8";
export var messageInputContainer = "_o1-h";
export var normal = "_o1-7";
export var replyCard = "_o1-f";
export var subtleButton = "_o1-1";
export var subtleButtonIconContainer = "_o1-2";
export var toggleViewRepliesButton = "_o1-c";
export var wrappingText = "_o1-g";